import React, { useEffect, useRef } from "react";
import { Controller } from "react-hook-form";
import Select from "react-select";

import { ErrorMessage } from "./error_message";

const OrgSelect = ({ form, orgOptions }) => {
  const selectRef = useRef();
  useEffect(() => {
    selectRef.current.focus();
  }, []);
  const selectStyles = {
    control: (base, state) => ({
      ...base,
      boxSizing: "border-box",
      fontFamily: "var(--sans-font-family)",
      fontWeight: "var(--font-weight-normal)",
      lineHeight: "calc(10 / 7)",
      height: "34px",
      minHeight: "34px",
      fontSize: "14px",
      background: state.isDisabled
        ? "#F2F2F2"
        : "linear-gradient(180deg, #FFFFFF 0%, #F5F5F5 100%)",
    }),
    placeholder: (base) => ({
      ...base,
      color: "var(--black-tint-70)",
      fontSize: "14px",
      fontFamily: "var(--sans-font-family)",
    }),
    valueContainer: (base) => ({
      ...base,
      transform: "translateY(-2px)",
      color: "var(--black-tint-10)",
      fontFamily: "var(--sans-font-family)",
      fontSize: "14px",
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: "14px",
      color: "var(--black-tint-10)",
      fontFamily: "var(--sans-font-family)",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    indicatorContainer: (base) => ({
      ...base,
      transform: "translateY(-2px)",
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? "var(--blue)" : "inherit",
      color: state.isFocused ? "var(--white)" : "inherit",
      fontSize: "14px",
      fontFamily: "var(--sans-font-family)",
    }),
  };
  return (
    <label>
      <p className="text-black-tint-40 bold body-s mb1">Organization</p>
      <div>
        <Controller
          name="org"
          id="org-select"
          as={
            <Select
              styles={selectStyles}
              options={orgOptions}
              classNamePrefix="react-select"
              placeholder="Select Org"
              isDisabled={!orgOptions.length}
              isSearchable
              isClearable={false}
              ref={selectRef}
            />
          }
          rules={{ required: true }}
          control={form.control}
        />
      </div>

      {orgOptions.length > 1 && form.errors.org?.type === "required" ? (
        <ErrorMessage msg="Please select an organization." />
      ) : null}
    </label>
  );
};

export { OrgSelect };
